import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutChargeCodeXref extends Layout {
    buttonExpand: Button;
    horizontalspacerForChargeCodeEdi: HorizontalSpacer;
    labelCrossRef: Label;
    panelChargeCode: Panel;
    panelChargeCodeEdiButtons: Panel;
    panelCollapsible: Panel;
    panelHeader: Panel;
    sourceChargeCodeEdi: DataSource;
    tableCrossRef: Table;
}
